import { useMemo } from 'react'
import { IGrowerItem } from '../../../../../modules/API/Defaults/models/growers'
import { IProductListItemNode } from '../../../../../modules/API/Defaults/models/productListNode'
import { IWarhouseListItem } from '../../../../../modules/API/Defaults/models/warhouseList'
import { ISortingListItem } from '../../../../../modules/API/Miun/models/sortingList'
import DateField from '../../orders/Components/DateField'
import IconTextField from '../../../../../generic/ui/Input/IconTextField'
import TagIcon from '../../../../../generic/icons/IconLib/TagIcon'
import { AccentButton } from '../../../../../generic/ui/Button/AccentButton'
import GrowerSelector from '../../../../../generic/ui/Selectors/GrowerSelector'
import WarehouseSelector from '../../../../../generic/ui/Selectors/WarehouseSelector'
import ProductForSortingSelector from '../../../../../generic/ui/Selectors/ProductForSortingSelector'
import VarietySelector from '../../../../../generic/ui/Selectors/VarietySelector'
import {
    FormShell,
    FormGrid,
    FormField,
    FormFooter,
} from '../../../../../generic/ui/FormLayout'
import useCreateSorting from '../services/hooks/useCreateSorting'

type Props = {
    productList: IProductListItemNode[]
    dataGrowers: IGrowerItem[]
    warhouseList: IWarhouseListItem[]
    closeFunc: () => void
    uppendData: (data: ISortingListItem) => void
}

const CreateSorting: React.FC<Props> = ({
    productList,
    dataGrowers,
    closeFunc,
    warhouseList,
    uppendData,
}) => {
    const {
        sortingCreateDate,
        setSortingCreateDate,
        grower,
        setGrower,
        product,
        setProduct,
        variety,
        setVariety,
        sortingReference,
        setSortingReference,
        warhouse,
        setWarhouse,
        varietyList,
        defaultProduct,
        defaultVariety,
        defaultTransit,
        isRequireVariety,
        user,
        isAllowToCreate,
        postCreateSorting,
    } = useCreateSorting({ uppendData, closeFunc })

    const growerObj = useMemo(
        () => dataGrowers.find((g) => g.GrowerID === grower) ?? null,
        [dataGrowers, grower],
    )
    const productObj = useMemo(
        () => productList.find((p) => p.ProductID === (product || defaultProduct)) ?? null,
        [productList, product, defaultProduct],
    )
    const warehouseDefault = warhouse || defaultTransit || (user ? Number(user.tranzit) : 0)
    const warehouseObj = useMemo(
        () => warhouseList.find((w) => w.WarehouseID === warehouseDefault) ?? null,
        [warhouseList, warehouseDefault],
    )
    const varietyObj = useMemo(
        () => varietyList.find((v) => v.VarietyID === (variety || defaultVariety)) ?? null,
        [varietyList, variety, defaultVariety],
    )

    return (
        <FormShell>
            <FormGrid>
                <FormField label='תאריך'>
                    <DateField
                        selected={sortingCreateDate}
                        onChange={(d) => d && setSortingCreateDate(d)}
                    />
                </FormField>

                <FormField label='אסמכתא' required={!sortingReference}>
                    <IconTextField
                        type='number'
                        value={sortingReference || ''}
                        onChange={(e) => setSortingReference(+e.target.value)}
                        leadingIcon={<TagIcon />}
                        placeholder='אסמכתא'
                    />
                </FormField>

                <FormField label='מגדל' required={!grower}>
                    <GrowerSelector
                        growers={dataGrowers}
                        value={growerObj}
                        onSelect={(g) => setGrower(g?.GrowerID ?? 0)}
                    />
                </FormField>

                <FormField label='מחסן / טרנזיט' required={!warehouseDefault}>
                    <WarehouseSelector
                        warehouses={warhouseList}
                        value={warehouseObj}
                        onSelect={(w) => setWarhouse(w?.WarehouseID ?? 0)}
                    />
                </FormField>
                
                <FormField label='פריט' required={!product} fullWidth>
                    <ProductForSortingSelector
                        items={productList}
                        value={productObj}
                        onSelect={(p) => {
                            setProduct(p?.ProductID ?? 0)
                            setVariety(0)
                        }}
                    />
                </FormField>

                {product ? (
                    <FormField
                        label='זן'
                        required={!!isRequireVariety && !variety}
                        fullWidth
                    >
                        <VarietySelector
                            items={varietyList}
                            value={varietyObj}
                            onSelect={(v) => setVariety(v?.VarietyID ?? 0)}
                        />
                    </FormField>
                ) : null}
            </FormGrid>

            <FormFooter>
                <AccentButton
                    type='button'
                    onClick={postCreateSorting}
                    disabled={!isAllowToCreate}
                    fullWidth={false}
                >
                    שמור
                </AccentButton>
            </FormFooter>
        </FormShell>
    )
}

export default CreateSorting
